import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Techstack from "../About/Techstack";
import Toolstack from "../About/Toolstack";
import './Skills.css';

function Skills() {
  return (
    <Container fluid className="skills-section" id="skills">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="animate-fade-in-up">
              <h1 className="project-heading text-center mb-5">
                Professional <strong className="text-gradient">Skills</strong>
              </h1>
            </div>
            
            <Row className="justify-content-center">
              <Col lg={6} className="mb-5">
                <div className="animate-fade-in-up">
                  <h2 className="skills-section-heading text-center mb-4">
                    <strong className="text-gradient">Tech Stack</strong> & Platforms
                  </h2>
                </div>
                <Techstack />
              </Col>
              
              <Col lg={6} className="mb-5">
                <div className="animate-fade-in-up">
                  <h2 className="skills-section-heading text-center mb-4">
                    <strong className="text-gradient">Development</strong> Environment
                  </h2>
                </div>
                <Toolstack />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Skills;